const editableFields = [
  'promoShowcaseEnabled', 'promoShowcaseUrl', 'promoShowcaseApiKey', 'promoShowcaseApiSecret',
  'promoShowcaseBlogConnectorPath', 'requestDesignerLabel', 'designerTeamUserIds',
];

// Toggles submit just their explicit override; Save submits only edited fields.
// Hosting metadata, membership and sync metadata are never sent as snapshots.
export function showcaseSettingsPatch(saved, current, override = {}) {
  const explicit = Object.keys(override).length > 0;
  const patch = Object.fromEntries(editableFields.filter(key => explicit
    ? Object.prototype.hasOwnProperty.call(override, key)
    : JSON.stringify(current[key]) !== JSON.stringify(saved[key]))
    .map(key => [key, explicit ? override[key] : current[key]]));
  const hosting = Object.fromEntries(['publicUrl', 'dnsTarget'].filter(key => explicit
    ? Object.prototype.hasOwnProperty.call(override.promoShowcaseHosting || {}, key)
    : current.promoShowcaseHosting?.[key] !== saved.promoShowcaseHosting?.[key])
    .map(key => [key, (explicit ? override : current).promoShowcaseHosting?.[key]]));
  if (Object.keys(hosting).length) patch.promoShowcaseHosting = hosting;
  return patch;
}
